module.exports = __webpack_public_path__ + "static/Group_6110_2x-ac8d9dc4951c12a42c362159072a69f7.png";